import { toString, Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, makeUnion, name, getUnionCases, record_type, option_type, union_type, int32_type, anonRecord_type, list_type, string_type, class_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { TeamStatus as TeamStatus_1, AdminModels_TeamCard, TeamStatus_$reflection, AdminModels_TeamCard_$reflection, RESP$1_$reflection, AdminModels_TeamRecord_$reflection } from "../shared/Shared.fs.js";
import { empty as empty_1, FSharpMap__Remove, FSharpMap__Add } from "./fable_modules/fable-library.4.10.0/Map.js";
import { newGuid } from "./fable_modules/fable-library.4.10.0/Guid.js";
import { urlForTeam, apiCmd, noCmd } from "./Common.fs.js";
import { isNullOrWhiteSpace } from "./fable_modules/fable-library.4.10.0/String.js";
import { isEmpty, sortBy, reverse, empty, cons, singleton, filter } from "./fable_modules/fable-library.4.10.0/List.js";
import { int32ToString, defaultOf, equals, comparePrimitives } from "./fable_modules/fable-library.4.10.0/Util.js";
import { value as value_3, defaultArg } from "./fable_modules/fable-library.4.10.0/Option.js";
import { tryFind, equalsWith } from "./fable_modules/fable-library.4.10.0/Array.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import { empty as empty_2, collect, map, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import * as react from "react";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { HTMLAttr, DOMAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { inputModal } from "./MainTemplates.fs.js";
import { Internal_updateInputValue } from "./fable_modules/Fable.Elmish.React.5.0.0/./common.fs.js";
import { toString as toString_1 } from "./fable_modules/fable-library.4.10.0/Date.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Exn", "DeleteError", "GetTeamsResp", "CreateTeam", "CreateTeamResp", "CreateDlgChange", "CreateDlgOk", "CreateDlgCancel", "ToggleCard", "GetTeamResp", "UpdateName", "UpdateStatus", "UpdateToken", "CancelCard", "SubmitCard", "SubmitResp", "ChangeStatus"];
    }
}

export function Msg_$reflection() {
    return union_type("AdminTeams.Msg", [], Msg, () => [[["Item", class_type("System.Exception")]], [["Item", string_type]], [["Item", RESP$1_$reflection(list_type(AdminModels_TeamRecord_$reflection()))]], [], [["Item", RESP$1_$reflection(anonRecord_type(["Record", AdminModels_TeamRecord_$reflection()]))]], [["Item", string_type]], [], [], [["Item", int32_type]], [["Item", RESP$1_$reflection(AdminModels_TeamCard_$reflection())]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [], [], [["Item", RESP$1_$reflection(AdminModels_TeamRecord_$reflection())]], [["Item1", int32_type], ["Item2", TeamStatus_$reflection()]]]);
}

export class Model extends Record {
    constructor(Teams, Errors, CardIsLoading, Card, CreateDlg) {
        super();
        this.Teams = Teams;
        this.Errors = Errors;
        this.CardIsLoading = CardIsLoading;
        this.Card = Card;
        this.CreateDlg = CreateDlg;
    }
}

export function Model_$reflection() {
    return record_type("AdminTeams.Model", [], Model, () => [["Teams", list_type(AdminModels_TeamRecord_$reflection())], ["Errors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["CardIsLoading", option_type(int32_type)], ["Card", option_type(AdminModels_TeamCard_$reflection())], ["CreateDlg", option_type(string_type)]]);
}

export function addError(txt, model) {
    let copyOfStruct;
    return new Model(model.Teams, FSharpMap__Add(model.Errors, (copyOfStruct = newGuid(), copyOfStruct), txt), model.CardIsLoading, model.Card, model.CreateDlg);
}

export function delError(id, model) {
    return new Model(model.Teams, FSharpMap__Remove(model.Errors, id), model.CardIsLoading, model.Card, model.CreateDlg);
}

export function loading(cardId, model) {
    return new Model(model.Teams, model.Errors, cardId, model.Card, model.CreateDlg);
}

export function editing(model) {
    return new Model(model.Teams, model.Errors, void 0, model.Card, model.CreateDlg);
}

export function createCmd(api, model) {
    const matchValue = model.CreateDlg;
    if (matchValue == null) {
        return noCmd(model);
    }
    else {
        return apiCmd(api.createTeam, {
            TeamName: matchValue,
        }, (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(0, [Item_1])), new Model(model.Teams, model.Errors, model.CardIsLoading, model.Card, void 0));
    }
}

export function toggleCard(api, teamId, model) {
    if (model.CardIsLoading == null) {
        const matchValue_1 = model.Card;
        let matchResult, card_2;
        if (matchValue_1 != null) {
            if (matchValue_1.TeamId === teamId) {
                matchResult = 0;
                card_2 = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return noCmd(new Model(model.Teams, model.Errors, model.CardIsLoading, void 0, model.CreateDlg));
            default:
                return apiCmd(api.getTeamCard, {
                    TeamId: teamId,
                }, (Item) => (new Msg(9, [Item])), (Item_1) => (new Msg(0, [Item_1])), loading(teamId, new Model(model.Teams, model.Errors, model.CardIsLoading, void 0, model.CreateDlg)));
        }
    }
    else {
        return noCmd(model);
    }
}

export function validateName(txt) {
    if (isNullOrWhiteSpace(txt)) {
        return "Name is required";
    }
    else {
        return "";
    }
}

export function updateCard(f, model) {
    const matchValue = model.Card;
    if (matchValue != null) {
        return new Model(model.Teams, model.Errors, model.CardIsLoading, f(matchValue), model.CreateDlg);
    }
    else {
        return model;
    }
}

export function validate(card_1) {
    return filter((s) => (s !== ""), singleton(validateName(card_1.TeamName)));
}

export function submitCard(api, model) {
    const matchValue = model.Card;
    if (matchValue == null) {
        return noCmd(model);
    }
    else {
        const card_1 = matchValue;
        return apiCmd(api.updateTeamCard, card_1, (Item) => (new Msg(15, [Item])), (Item_1) => (new Msg(0, [Item_1])), loading(card_1.TeamId, model));
    }
}

export function replaceRecord(record, model) {
    return new Model(cons(record, filter((q) => (q.TeamId !== record.TeamId), model.Teams)), model.Errors, model.CardIsLoading, model.Card, model.CreateDlg);
}

export function init(api, user) {
    return apiCmd(api.getTeams, void 0, (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(0, [Item_1])), new Model(empty(), empty_1({
        Compare: comparePrimitives,
    }), void 0, void 0, void 0));
}

export function update(api, user, msg, cm) {
    let matchResult, id, res_4, txt_4, res_5, teamId, res_6, txt_5, txt_6, txt_7, res_7, status, teamId_1, ex, txt_9;
    switch (msg.tag) {
        case 2: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 1;
                res_4 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult;
                const msg_1 = msg;
                const pi_1 = tryFind((pi) => (name(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1 == null) {
                    activePatternResult = void 0;
                }
                else {
                    const pi$0027 = pi_1;
                    let msgType;
                    let copyOfStruct = msg_1;
                    msgType = Msg_$reflection();
                    if (isUnion(msgType)) {
                        const objArray = getUnionFields(msg_1, msgType)[1];
                        if (objArray.length === 1) {
                            try {
                                const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult = ((name(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                            }
                            catch (matchValue) {
                                activePatternResult = void 0;
                            }
                        }
                        else {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                if (activePatternResult != null) {
                    matchResult = 17;
                    txt_9 = activePatternResult;
                }
                else {
                    matchResult = 18;
                }
            }
            break;
        }
        case 3: {
            matchResult = 2;
            break;
        }
        case 5: {
            matchResult = 3;
            txt_4 = msg.fields[0];
            break;
        }
        case 7: {
            matchResult = 4;
            break;
        }
        case 6: {
            matchResult = 5;
            break;
        }
        case 4: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 6;
                res_5 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_1) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 17;
                    txt_9 = activePatternResult_1;
                }
                else {
                    matchResult = 18;
                }
            }
            break;
        }
        case 8: {
            matchResult = 7;
            teamId = msg.fields[0];
            break;
        }
        case 9: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 8;
                res_6 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_2;
                const msg_3 = msg;
                const pi_1_2 = tryFind((pi_3) => (name(pi_3) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_2 == null) {
                    activePatternResult_2 = void 0;
                }
                else {
                    const pi$0027_2 = pi_1_2;
                    let msgType_2;
                    let copyOfStruct_2 = msg_3;
                    msgType_2 = Msg_$reflection();
                    if (isUnion(msgType_2)) {
                        const objArray_3 = getUnionFields(msg_3, msgType_2)[1];
                        if (objArray_3.length === 1) {
                            try {
                                const patternInput_1_2 = getUnionFields(getRecordField(objArray_3[0], pi$0027_2), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_2 = ((name(patternInput_1_2[0]) === "Error") ? patternInput_1_2[1][0] : void 0);
                            }
                            catch (matchValue_2) {
                                activePatternResult_2 = void 0;
                            }
                        }
                        else {
                            activePatternResult_2 = void 0;
                        }
                    }
                    else {
                        activePatternResult_2 = void 0;
                    }
                }
                if (activePatternResult_2 != null) {
                    matchResult = 17;
                    txt_9 = activePatternResult_2;
                }
                else {
                    matchResult = 18;
                }
            }
            break;
        }
        case 10: {
            matchResult = 9;
            txt_5 = msg.fields[0];
            break;
        }
        case 11: {
            matchResult = 10;
            txt_6 = msg.fields[0];
            break;
        }
        case 12: {
            matchResult = 11;
            txt_7 = msg.fields[0];
            break;
        }
        case 13: {
            matchResult = 12;
            break;
        }
        case 14: {
            matchResult = 13;
            break;
        }
        case 15: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 14;
                res_7 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_3;
                const msg_4 = msg;
                const pi_1_3 = tryFind((pi_4) => (name(pi_4) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_3 == null) {
                    activePatternResult_3 = void 0;
                }
                else {
                    const pi$0027_3 = pi_1_3;
                    let msgType_3;
                    let copyOfStruct_3 = msg_4;
                    msgType_3 = Msg_$reflection();
                    if (isUnion(msgType_3)) {
                        const objArray_4 = getUnionFields(msg_4, msgType_3)[1];
                        if (objArray_4.length === 1) {
                            try {
                                const patternInput_1_3 = getUnionFields(getRecordField(objArray_4[0], pi$0027_3), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_3 = ((name(patternInput_1_3[0]) === "Error") ? patternInput_1_3[1][0] : void 0);
                            }
                            catch (matchValue_3) {
                                activePatternResult_3 = void 0;
                            }
                        }
                        else {
                            activePatternResult_3 = void 0;
                        }
                    }
                    else {
                        activePatternResult_3 = void 0;
                    }
                }
                if (activePatternResult_3 != null) {
                    matchResult = 17;
                    txt_9 = activePatternResult_3;
                }
                else {
                    matchResult = 18;
                }
            }
            break;
        }
        case 16: {
            matchResult = 15;
            status = msg.fields[1];
            teamId_1 = msg.fields[0];
            break;
        }
        case 0: {
            matchResult = 16;
            ex = msg.fields[0];
            break;
        }
        default: {
            matchResult = 0;
            id = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return noCmd(delError(id, cm));
        case 1:
            return noCmd(new Model(res_4, cm.Errors, cm.CardIsLoading, cm.Card, cm.CreateDlg));
        case 2:
            return noCmd(new Model(cm.Teams, cm.Errors, cm.CardIsLoading, cm.Card, ""));
        case 3:
            return noCmd(new Model(cm.Teams, cm.Errors, cm.CardIsLoading, cm.Card, txt_4));
        case 4:
            return noCmd(new Model(cm.Teams, cm.Errors, cm.CardIsLoading, cm.Card, void 0));
        case 5:
            return createCmd(api, cm);
        case 6:
            return noCmd(new Model(cons(res_5.Record, cm.Teams), cm.Errors, cm.CardIsLoading, cm.Card, cm.CreateDlg));
        case 7:
            return toggleCard(api, teamId, cm);
        case 8:
            return noCmd(editing(new Model(cm.Teams, cm.Errors, cm.CardIsLoading, res_6, cm.CreateDlg)));
        case 9:
            return noCmd(updateCard((c) => (new AdminModels_TeamCard(c.TeamId, txt_5, c.TeamStatus, c.EntryToken, c.RegistrationDate)), cm));
        case 10:
            return noCmd(updateCard((c_1) => {
                let matchValue_4, array_4;
                return new AdminModels_TeamCard(c_1.TeamId, c_1.TeamName, defaultArg((matchValue_4 = ((array_4 = getUnionCases(TeamStatus_$reflection()), array_4.filter((case$) => (name(case$) === txt_6)))), (!equalsWith(equals, matchValue_4, defaultOf()) && (matchValue_4.length === 1)) ? makeUnion(matchValue_4[0], []) : void 0), new TeamStatus_1(0, [])), c_1.EntryToken, c_1.RegistrationDate);
            }, cm));
        case 11:
            return noCmd(updateCard((c_2) => (new AdminModels_TeamCard(c_2.TeamId, c_2.TeamName, c_2.TeamStatus, txt_7, c_2.RegistrationDate)), cm));
        case 12:
            return noCmd(new Model(cm.Teams, cm.Errors, cm.CardIsLoading, void 0, cm.CreateDlg));
        case 13:
            return submitCard(api, cm);
        case 14:
            return noCmd(replaceRecord(res_7, editing(new Model(cm.Teams, cm.Errors, cm.CardIsLoading, void 0, cm.CreateDlg))));
        case 15:
            return apiCmd(api.changeTeamStatus, {
                TeamId: teamId_1,
                TeamStatus: status,
            }, (Item) => (new Msg(15, [Item])), (Item_1) => (new Msg(0, [Item_1])), loading(teamId_1, cm));
        case 16:
            return noCmd(editing(addError(ex.message, cm)));
        case 17:
            return noCmd(editing(addError(txt_9, cm)));
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, user, model) {
    const children_62 = toList(delay(() => {
        let children_8, children_6, children_4;
        return append(singleton_1((children_8 = [react.createElement("div", {
            className: "level-left",
        }), (children_6 = [(children_4 = [react.createElement("button", {
            className: "button",
            onClick: (_arg) => {
                dispatch(new Msg(3, []));
            },
        }, "Create New Team")], react.createElement("p", {
            className: "level-item",
        }, ...children_4))], react.createElement("div", {
            className: "level-right",
        }, ...children_6))], react.createElement("nav", {
            className: "level",
        }, ...children_8))), delay(() => append(map((error) => {
            const children_12 = [react.createElement("button", {
                className: "delete",
                onClick: (_arg_1) => {
                    dispatch(new Msg(1, [error[0]]));
                },
            }), error[1]];
            return react.createElement("div", {
                className: "notification is-danger is-light",
            }, ...children_12);
        }, model.Errors), delay(() => {
            let children_60, children_26, children_24, props_14, props_16, props_22, children_58;
            return append(singleton_1((children_60 = [(children_26 = [(children_24 = [(props_14 = [["style", {
                width: "30px",
            }]], react.createElement("th", keyValueList(props_14, 1), "")), (props_16 = [["style", {
                width: "30px",
            }]], react.createElement("th", keyValueList(props_16, 1), "Id")), react.createElement("th", {}, "Name"), react.createElement("th", {}, "Entry URL"), (props_22 = [["style", {
                width: "60px",
            }]], react.createElement("th", keyValueList(props_22, 1), "Status"))], react.createElement("tr", {}, ...children_24))], react.createElement("thead", {}, ...children_26)), (children_58 = toList(delay(() => collect((team) => {
                let props_50, children_50, children_30, props_28, children_28, children_32, children_36, children_48, props_46, children_46;
                let hasCard;
                const matchValue = model.Card;
                let matchResult, card_2;
                if (matchValue != null) {
                    if (matchValue.TeamId === team.TeamId) {
                        matchResult = 0;
                        card_2 = matchValue;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        hasCard = true;
                        break;
                    }
                    default:
                        hasCard = false;
                }
                let isLoading;
                const matchValue_1 = model.CardIsLoading;
                let matchResult_1, id_1;
                if (matchValue_1 != null) {
                    if (matchValue_1 === team.TeamId) {
                        matchResult_1 = 0;
                        id_1 = matchValue_1;
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        isLoading = true;
                        break;
                    }
                    default:
                        isLoading = false;
                }
                return append(singleton_1((props_50 = [Helpers_classList([["has-text-weight-bold", equals(team.TeamStatus, new TeamStatus_1(0, []))], ["has-text-danger", equals(team.TeamStatus, new TeamStatus_1(2, []))]])], (children_50 = [(children_30 = [(props_28 = [Helpers_classList([["button", true], ["is-small", true], ["is-loading", isLoading]]), new DOMAttr(40, [(_arg_2) => {
                    dispatch(new Msg(8, [team.TeamId]));
                }])], (children_28 = [hasCard ? "-" : "+"], react.createElement("button", keyValueList(props_28, 1), ...children_28)))], react.createElement("th", {}, ...children_30)), (children_32 = [int32ToString(team.TeamId)], react.createElement("td", {}, ...children_32)), react.createElement("td", {}, team.TeamName), (children_36 = [urlForTeam(user.QuizId, team.TeamId, team.EntryToken)], react.createElement("td", {}, ...children_36)), (children_48 = [(props_46 = [["style", {
                    display: "flex",
                }]], (children_46 = toList(delay(() => append(singleton_1(toString(team.TeamStatus)), delay(() => (equals(team.TeamStatus, new TeamStatus_1(0, [])) ? append(singleton_1(" "), delay(() => {
                    let children_40, children_38;
                    return append(singleton_1((children_40 = [(children_38 = [Fa_i(singleton(new Fa_IconOption(11, ["far fa-thumbs-up"])), [])], react.createElement("span", {
                        className: "icon has-text-info",
                    }, ...children_38))], react.createElement("button", {
                        className: "button is-small is-white",
                        title: "Admit",
                        onClick: (_arg_3) => {
                            dispatch(new Msg(16, [team.TeamId, new TeamStatus_1(1, [])]));
                        },
                    }, ...children_40))), delay(() => {
                        let children_44, children_42;
                        return singleton_1((children_44 = [(children_42 = [Fa_i(singleton(new Fa_IconOption(11, ["far fa-thumbs-down"])), [])], react.createElement("span", {
                            className: "icon has-text-danger",
                        }, ...children_42))], react.createElement("button", {
                            className: "button is-small is-white",
                            title: "Reject",
                            onClick: (_arg_4) => {
                                dispatch(new Msg(16, [team.TeamId, new TeamStatus_1(2, [])]));
                            },
                        }, ...children_44)));
                    }));
                })) : empty_2()))))), react.createElement("div", keyValueList(props_46, 1), ...children_46)))], react.createElement("td", {}, ...children_48))], react.createElement("tr", keyValueList(props_50, 1), ...children_50)))), delay(() => {
                    let children_56, children_54;
                    return hasCard ? singleton_1((children_56 = [react.createElement("th", {}), (children_54 = [card(dispatch, value_3(model.Card), isLoading)], react.createElement("td", {
                        colSpan: 4,
                    }, ...children_54))], react.createElement("tr", {}, ...children_56))) : empty_2();
                }));
            }, reverse(sortBy((q) => q.TeamId, model.Teams, {
                Compare: comparePrimitives,
            }))))), react.createElement("tbody", {}, ...children_58))], react.createElement("table", {
                className: "table is-fullwidth is-hoverable",
            }, ...children_60))), delay(() => {
                const matchValue_2 = model.CreateDlg;
                if (matchValue_2 == null) {
                    return empty_2();
                }
                else {
                    return singleton_1(inputModal(dispatch, "Enter Team\'s Name", matchValue_2, (Item) => (new Msg(5, [Item])), new Msg(6, []), new Msg(7, [])));
                }
            }));
        }))));
    }));
    return react.createElement("div", {}, ...children_62);
}

export function card(dispatch, card_1, isLoading) {
    let children_36, children_16, children_8, children_14, children_12, children_34, children_26, children_24, props_26, value_2, children_22, children_32, children_30, children_28, children_46, children_40, children_44;
    const children_48 = [(children_36 = [(children_16 = [(children_8 = toList(delay(() => {
        let children_2;
        return append(singleton_1((children_2 = ["Name", react.createElement("span", {
            className: "has-text-danger",
        }, "*")], react.createElement("label", {
            className: "label",
        }, ...children_2))), delay(() => {
            let children_4, props_4;
            const error = validateName(card_1.TeamName);
            return append(singleton_1((children_4 = [(props_4 = [Helpers_classList([["input", true], ["is-danger", error !== ""]]), new HTMLAttr(159, ["text"]), new HTMLAttr(128, ["Team Name"]), new HTMLAttr(115, [64]), ["ref", (e) => {
                Internal_updateInputValue(card_1.TeamName, e);
            }], new DOMAttr(9, [(ev) => {
                dispatch(new Msg(10, [ev.target.value]));
            }])], react.createElement("input", keyValueList(props_4, 1)))], react.createElement("div", {
                className: "control",
            }, ...children_4))), delay(() => singleton_1(react.createElement("p", {
                className: "help is-danger",
            }, error))));
        }));
    })), react.createElement("div", {
        className: "field",
    }, ...children_8)), (children_14 = [react.createElement("label", {
        className: "label",
    }, "Entry token"), (children_12 = [react.createElement("input", {
        className: "input",
        type: "text",
        ref: (e_1) => {
            Internal_updateInputValue(card_1.EntryToken, e_1);
        },
        onChange: (ev_1) => {
            dispatch(new Msg(12, [ev_1.target.value]));
        },
    })], react.createElement("div", {
        className: "control",
    }, ...children_12))], react.createElement("div", {
        className: "field",
    }, ...children_14))], react.createElement("div", {
        className: "column",
    }, ...children_16)), (children_34 = [(children_26 = [react.createElement("label", {
        className: "label",
    }, "Status"), (children_24 = [(props_26 = [(value_2 = toString(card_1.TeamStatus), ["ref", (e_2) => {
        Internal_updateInputValue(value_2, e_2);
    }]), new DOMAttr(9, [(ev_2) => {
        dispatch(new Msg(11, [ev_2.target.value]));
    }])], (children_22 = toList(delay(() => map((case$) => {
        const children_20 = [name(case$)];
        return react.createElement("option", {}, ...children_20);
    }, getUnionCases(TeamStatus_$reflection())))), react.createElement("select", keyValueList(props_26, 1), ...children_22)))], react.createElement("div", {
        className: "select",
    }, ...children_24))], react.createElement("div", {
        className: "control",
    }, ...children_26)), (children_32 = [(children_30 = [(children_28 = ["Registration date ", toString_1(card_1.RegistrationDate, "dd.MM.yyyy HH:mm")], react.createElement("li", {}, ...children_28))], react.createElement("ul", {}, ...children_30))], react.createElement("div", {
        className: "content",
    }, ...children_32))], react.createElement("div", {
        className: "column",
    }, ...children_34))], react.createElement("div", {
        className: "columns",
    }, ...children_36)), (children_46 = [(children_40 = toList(delay(() => {
        const hasErrors = !isEmpty(validate(card_1));
        return singleton_1(react.createElement("button", {
            className: "button is-dark ",
            disabled: hasErrors,
            onClick: (_arg) => {
                dispatch(new Msg(14, []));
            },
        }, "Submit"));
    })), react.createElement("div", {
        className: "control",
    }, ...children_40)), (children_44 = [react.createElement("button", {
        className: "button",
        onClick: (_arg_1) => {
            dispatch(new Msg(13, []));
        },
    }, "Cancel")], react.createElement("div", {
        className: "control",
    }, ...children_44))], react.createElement("div", {
        className: "field is-grouped",
    }, ...children_46))];
    return react.createElement("div", {}, ...children_48);
}

